const BADGE_HEIGHT_IN_MM = 53.98;
const BADGE_WIDTH_IN_MM = 85.6;
const WORKER_PICTURE_WIDTH_IN_MM = 24;
const WORKER_PICTURE_HEIGHT_IN_MM = 30;

const basePath = process.env.REACT_APP_BASE_PATH ?? "/";

export const WORK_BADGE_PDF_DEFAULT_SETTINGS = {
  BADGE: {
    HEIGHT_IN_MM: BADGE_HEIGHT_IN_MM,
    WIDTH_IN_MM: BADGE_WIDTH_IN_MM,
    ASPECT_RATIO: BADGE_WIDTH_IN_MM / BADGE_HEIGHT_IN_MM,
    BORDER_WIDTH_IN_MM: 0.5,
    BADGE_MARGIN_IN_MM: 0,
    PADDING_IN_MM: 4,
    BORDER_RADIUS_IN_MM: 3.5,
  },
  WORKER_PICTURE: {
    WIDTH_IN_MM: WORKER_PICTURE_WIDTH_IN_MM,
    HEIGHT_IN_MM: WORKER_PICTURE_HEIGHT_IN_MM,
    ASPECT_RATIO: WORKER_PICTURE_WIDTH_IN_MM / WORKER_PICTURE_HEIGHT_IN_MM,
    DEFAULT_URL: `${basePath}assets/images/avatar.jpg`,
    MARGIN_RIGHT_IN_MM: 3,
    BORDER_RADIUS_IN_MM: 1.5,
  },
  CLIPBOARD_LOGO: {
    DEFAULT_URL: `${basePath}assets/logo/bunny.png`,
  },
  TEXT: {
    FONTS: {
      REGULAR: "Helvetica",
      BOLD: "Helvetica-Bold",
    },
  },
  PALETTE: {
    PRIMARY: {
      // eslint-disable-next-line no-restricted-syntax
      FOREGROUND: "#0C1C43",
      // eslint-disable-next-line no-restricted-syntax
      BACKGROUND: "#FFFFFF",
    },
  },
};

export const ONE_MM_IN_POINTS = 2.834_645_669;
